/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import dataTool from 'echarts/extension/dataTool';
import sortBy from 'lodash/sortBy';
import uniqWith from 'lodash/uniqWith';
import uniq from 'lodash/uniq';
import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';
import ceil from 'lodash/ceil';
import differenceWith from 'lodash/differenceWith';
import some from 'lodash/some';
import groupBy from 'lodash/groupBy';
import statsLite from 'stats-lite';
import cacheAxios from '../../util/cacheAxios';
import abbreviateNumber from '../../util/abbreviateNumber';

const exepayAxios = axios.create();
const cache = new Map();
cacheAxios(exepayAxios, cache);

exepayAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });

  function companyComparator(c1, c2) {
    if (c1.uniqCode === c2.uniqCode &&
      c1.longName === c2.longName) {
      return true;
    }
    return false;
  }
  function getCompanyCut(val) {
    const coticker = val.split(',');
    return coticker[1].concat('-', coticker[2]);
  }
  function getRevNaming(lbl) {
    return 'REV:US$'.concat(abbreviateNumber(lbl));
  }

  const indicatorsMapping = {
    salary: 'Salary',
    bonus: 'Bonus',
    stockaward: 'Stock Award',
    optionaward: 'Option Award',
    nonequity: 'Non Equity',
    pension: 'Pension',
    other: 'Others',
    total_cash: 'Total Cash',
    total_direct_compensation: 'Total Direct Compensation',
    total_renumeration: 'Total Renumeration',
    total_cost: 'Total Cost',
  };
  const indicatorsXMapping = {
    totalRevenueUsd: 'Revenue',
    netIncomeUsd: 'Net Income',
  };
  const grid = [
    {
      right: '12%',
      bottom: '11%',
      },
    ];
  const legend = {
    top: '5%',
    right: '3%',
    orient: 'vertical',
    align: 'right',
  };
  const label = {
    normal: {
      show: false,
      formatter: function slb1(params) {
        return `${getCompanyCut(params.seriesName)}`;
      },
    },
    emphasis: {
      show: true,
      formatter: function slb2(params) {
        return `${getCompanyCut(params.seriesName)}`;
      },
    },
  };
  const companyPlotMaxCount = 10;
  const companyPlotMinCountPerGrp = 3;

  function sortFloat(a, b) { return a - b; }

  function getGrouped(relevantIndicators) {
    return groupBy(relevantIndicators, 'graphUniqDataPoint');
  }
  function getSorted(grouped, trKey) {
    return Object.keys(grouped)
            .map(key => sortBy(grouped[key], trKey));
  }
  function getXdatas(sorted, trKey) {
    const xvalues = [];
    sorted.forEach(arr => arr.forEach((item) => {
      if (trKey === 'totalRevenueUsd') {
        if (!xvalues.includes(`${item.totalRevenueUsd}`)) {
          xvalues.push(`${item.totalRevenueUsd}`);
        }
      }
      if (trKey === 'netIncomeUsd') {
        if (!xvalues.includes(`${item.netIncomeUsd}`)) {
          xvalues.push(`${item.netIncomeUsd}`);
        }
      }
    }));
    return xvalues.sort(sortFloat);
  }
  function getSeries(state, grouped, sorted, trKey) {
    let series = [];
    series = Object.keys(grouped)
            .map((key, i) => {
              const array = {
                name: key,
                type: 'scatter',
                data: sorted[i].map((d) => {
                    let value = '';
                    value = d[state.yField] ? d[state.yField].toFixed(3) : '';
                    let v;
                    if (trKey === 'totalRevenueUsd') {
                      v = [
                        `${d.totalRevenueUsd}`,
                        value,
                      ];
                    }
                    if (trKey === 'netIncomeUsd') {
                      v = [
                        `${d.netIncomeUsd}`,
                        value,
                      ];
                    }
                    return v;
                  })
                  .filter(d => d[1] !== ''),
                symbolSize: 20,
                label,
              };
              return array;
            })
            .filter(item => item.data.length > 0);
    return series;
  }
export default {
  state: {
    loadingCompanies: false,
    loadingMainView: false,
    indicators: [],
    indicatorSelected: 'total_cost',
    indicatorXSelected: 'totalRevenueUsd',
    yField: 'valCompensation',
    companySelected: '',
    years: [],
    jobtitles: [],
    allsectors: [],
    relevantCompanies: [],
    relevantCompaniesIndicators: [],
    competitors: [],
    benefits: [],
    wadDisplayType: 'aggregate',
    chartEPOptions: {
      title: {
        left: 'center',
        top: '1%',
      },
      backgroundColor: '#fff',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
        formatter: (params) => {
          let tooltipcustom = '';
          tooltipcustom = tooltipcustom.concat('<div style="font-size:14pt;text-align:right;">', getRevNaming(params[0].data[0]), '</div>');
          for (let i = 0; i < params.length; i++) {
            tooltipcustom = tooltipcustom.concat('<table><tr><td style="background:', params[i].color, ';width:200px;">', getCompanyCut(params[i].seriesName), '</td><td style="width:10px;text-align:right;">US$</td><td style="width:100px;text-align:right;">', abbreviateNumber(params[i].value[1]));
            tooltipcustom = tooltipcustom.concat('</td></tr></table>');
          }
          return tooltipcustom;
        },
      },
      grid,
      toolbox: {
        feature: {
          saveAsImage: {
            show: true,
            title: 'save',
          },
        },
      },
      series: [{
        name: '',
        type: 'bar',
        barWidth: '25%',
        data: [],
      }],
      xAxis: {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow',
        },
        axisLabel: {
          type: 'value',
          formatter: (lbl) => {
            if (lbl >= 0) {
              return `US$${abbreviateNumber(lbl)}`;
            }
            return `(US$${abbreviateNumber(-lbl)})`;
          },
        },
      },
      yAxis: {
        splitLine: {
          show: false,
        },
        axisLabel: {
          type: 'value',
          formatter: (lbl) => {
            if (lbl >= 0) {
              return `US$${abbreviateNumber(lbl)}`;
            }
            return `(US$${abbreviateNumber(-lbl)})`;
          },
        },
      },
    },
  },
  mutations: {
    removeAllECompetitors(state) {
      state.competitors = [];
    },
    removeECompetitors(state, companies) {
      state.competitors = differenceWith(state.competitors, companies, companyComparator);
    },
    appendECompetitors(state, companies) {
      state.competitors = uniqWith(state.competitors.concat(companies), companyComparator);
    },

    setIndicators(state, indicators) {
      state.indicators = indicators;
    },
    setEIndicatorSelected(state, indicator) {
      state.indicatorSelected = indicator;
    },
    setEIndicatorXSelected(state, indicatorX) {
      state.indicatorXSelected = indicatorX;
    },

    setCompanySelected(state, company) {
      state.companySelected = company;
    },

    setYears(state, years) {
      state.years = years;
    },
    setJobTitles(state, jobtitles) {
      state.jobtitles = jobtitles;
    },
    setAllSectors(state, allsectors) {
      state.allsectors = allsectors;
    },

    setCompaniesLoading(state, value) {
      state.loadingCompanies = value;
    },
    setLoadingMainView(state, value) {
      state.loadingMainView = value;
    },

    setRelevantCompanies(state, companies) {
      state.relevantCompanies = companies;
    },
    setBenefits(state, benefits) {
      state.benefits = benefits;
    },

    setRelevantCompaniesIndicators(state, coIndicators) {
      state.relevantCompaniesIndicators = coIndicators;
    },
    setWhatDisplayType(state, dType) {
      state.wadDisplayType = dType;
    },
    unplotBox(state) {
    },
    unplotCompany(state) {
    },
    plotCompetitorsEPChart(state, {
      xAxisData,
      mSeries,
    }) {
      const title = {
        ...state.chartEPOptions.title,
      };
      title.text = indicatorsMapping[state.indicatorSelected].concat(' by ', indicatorsXMapping[state.indicatorXSelected]);
      const series = [state.chartEPOptions.series[0], ...mSeries];
      const yAxis = {
        ...state.chartEPOptions.yAxis,
      };
      let data = [...xAxisData];
      //  data = [...state.chartEPOptions.xAxis.data, ...xAxisData];
      data = uniq(data);

      const xAxis = {
        ...state.chartEPOptions.xAxis,
        data,
      };
      let newLegend = {
        ...legend,
        data: series.map(s => s.name).filter(n => n),
        formatter: function lg(name) {
          return `${getCompanyCut(name)}`;
        },
      };
      if (data.length > companyPlotMaxCount) {
        newLegend = {
          show: false,
        };
      }
      state.chartEPOptions = {
        ...state.chartEPOptions,
        clear: true,
        title,
        xAxis,
        yAxis,
        series,
      };
    },
  },
  actions: {
    initExecutivePayData({
      commit,
    }) {
      exepayAxios.get('/aims/api/executivepay/years')
        .then((res) => {
          if (res.status === 200) {
            res.data.sort();
            commit('setYears', res.data);
          }
        });
      exepayAxios.get('/aims/api/executivepay/jobs')
        .then((res) => {
          if (res.status === 200) {
            res.data.sort();
            commit('setJobTitles', res.data);
          }
        });
      exepayAxios.get('/aims/api/executivepay/sectors')
        .then((res) => {
          if (res.status === 200) {
            res.data.sort();
            commit('setAllSectors', res.data);
          }
        });
    },
    getCompaniesByYearJob({
      state,
      commit,
    }, {
      year,
      jobtitle,
    }) {
      commit('setCompaniesLoading', true);
      const query = {
        year,
        jobtitle,
      };
      exepayAxios.post('/aims/api/executivepay/companiesByYearJob', query, {
          cache: true,
          cacheKey: query.year.toString().concat(query.jobtitle),
        })
        .then((res) => {
          if (res.status === 200) {
            commit('setRelevantCompanies', res.data);
            const querybt = {
              uniqCode: [],
            };
            const companies = res.data;
            for (let i = 0, len = companies.length; i < len; i++) {
              querybt.uniqCode.push(companies[i].uniqCode);
            }
            exepayAxios.post('/aims/api/executivepay/indicatorsByUniqCode', querybt, {
                cache: true,
                cacheKey: 'bentype'.concat(querybt),
              })
              .then((resbt) => {
                if (resbt.status === 200) {
                  commit('setIndicators', resbt.data);
                }
              });

            commit('setCompaniesLoading', false);
            if (res.data && res.data.length > 0) {
              return res.data.map(c => c.longName);
            }
            return null;
          }

          return null;
        });
    },
    getBenefitsByCo({
      state,
      commit,
    }, {
      selectcos,
      selectpcts,
    }) {
      commit('setLoadingMainView', true);
      const query = {
        uniqCode: [],
        selectPCT: selectpcts,
      };
      for (let i = 0, len = selectcos.length; i < len; i++) {
        query.uniqCode.push(selectcos[i].uniqCode);
      }
      exepayAxios.post('/aims/api/executivepay/benefitsByCompanies', query, {
          cache: false,
          cacheKey: 'benco'.concat(query),
        })
        .then((res) => {
          if (res.status === 200) {
            commit('setLoadingMainView', false);
            commit('setBenefits', res.data);
          }
        });
    },
    getExecutivesPayChart({
      state,
      commit,
    }, {
      selectcos,
    }) {
      // commit('setLoadingMainView', true);
      const query = {
        uniqCode: [],
      };
      for (let i = 0, len = selectcos.length; i < len; i++) {
        query.uniqCode.push(selectcos[i].uniqCode);
      }
      exepayAxios.post('/aims/api/executivepay/companiesExecutivesPay', query, {
        cache: false,
        cacheKey: 'exepay'.concat(query),
      })
      .then((res) => {
        if (res.status === 200) {
          // commit('setLoadingMainView', false);
          commit('setRelevantCompaniesIndicators', res.data);
          if (state.wadDisplayType === 'graph') {
            const trKey = state.indicatorXSelected;
            let relevantIndicators = res.data.filter(
              item => item.benefitType === state.indicatorSelected &&
              item.totalRevenueUsd !== undefined);
            if (trKey === 'netIncomeUsd') {
              relevantIndicators = res.data.filter(
                item => item.benefitType === state.indicatorSelected &&
                item.netIncomeUsd !== undefined);
            }
            const sortedByRevenue = sortBy(relevantIndicators, trKey);
            const grouped = getGrouped(sortedByRevenue);
            const sorted = getSorted(grouped, trKey);
            const xDataValues = getXdatas(sorted, trKey);
            const series = getSeries(state, grouped, sorted, trKey);
            commit('plotCompetitorsEPChart', {
              xAxisData: xDataValues,
              mSeries: series,
            });
          }
        } else {
          commit('setRelevantCompaniesIndicators', []);
        }
      });
    },
    preparePlotExecutivePayChart({
      dispatch,
      commit,
      state,
    }, companySelections) {
      const trKey = state.indicatorXSelected;
      let relevantIndicators = companySelections.filter(
        item => item.benefitType === state.indicatorSelected && item.totalRevenueUsd !== undefined);
      if (trKey === 'netIncomeUsd') {
        relevantIndicators = companySelections.filter(
          item => item.benefitType === state.indicatorSelected && item.netIncomeUsd !== undefined);
      }
      const sortedByRevenue = sortBy(relevantIndicators, trKey);
      const grouped = getGrouped(sortedByRevenue);
      const sorted = getSorted(grouped, trKey);
      const xDataValues = getXdatas(sorted, trKey);
      const series = getSeries(state, grouped, sorted, trKey);
      // let sorted;
      // let xDataValues;
      // let series;
      // if (sortedByRevenue.length <= companyPlotMaxCount) {
      //   sorted = getSorted(grouped);
      //   xDataValues = getXdatas(sorted);
      //   series = getSeries(state, grouped, sorted);
      // } else {
      //   if (sortedByRevenue.length < (companyPlotMinCountPerGrp * companyPlotMaxCount)) {
      //     // 1 - 3 group with max 10 per group
      //     const maxgrp = ceil(sortedByRevenue.length / companyPlotMaxCount);
      //     for (let i = 0; i < maxgrp; i++) { // eslint-disable-line
      //     }
      //   } else {
      //     // 10 Group with min e.g. 3 per group
      //     for (let i = 0; i < companyPlotMaxCount; i++) { // eslint-disable-line
      //     }
      //   }
      //   sorted = getSorted(grouped);
      //   xDataValues = getXdatas(sorted);
      //   series = getSeries(state, grouped, sorted);
      // }
      commit('plotCompetitorsEPChart', {
        xAxisData: xDataValues,
        mSeries: series,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/executivePayModule.js